module.exports = __webpack_public_path__ + "Assets/c1bbbd49-cc08-4ec8-a63d-8cbd6936c666.ttf";